import { Controller, useFormContext } from 'react-hook-form'

import { CurrencyCentInput, FF2, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

type TotalBankFeesProps = {
  index: number
}

export const TotalBankFees = ({ index }: TotalBankFeesProps) => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name={`transactionsInfo.${index as 0}.totalBankFees`}
      control={control}
      rules={{ validate: (value) => Validators.required.notEmpty(value) }}
      render={({ field }) => (
        <FF2 required field={field} label="Total Bank Fees" input={(props) => <CurrencyCentInput {...props} />} />
      )}
    />
  )
}
